import { cancelForexOrder as cancelOnCore, getForexProductList } from "service/moneeflo/legacy-forex-order-api";

export type CancelPayload = {
  reason: string;
  /** The cancellation charge in paise, as a string: "0" for none. */
  feeMinor: string;
  order_id: number;
  redirectToRefund?: boolean;
  /** What can go back once the fee is off, in paise; carried to the refund page. */
  refundMinor?: string;
};
export type RateAndMargin = {
    l1_commission: number;
    l2_commission: number;
    l3_commission: number;
    l2_id: number;
    ibr_rate: number;
}
export type ProductDetail = {
    id: number;
    name: string;
    subCategory: string;
}
export type Product = {
    id: string;
    product_id: number;
    quantity: number;
    inr_amount: number;
    status: string;
    rate_and_margins: RateAndMargin[];
    product_detail: ProductDetail;
    country_currency_want: string;
    country_currency_have:string
}
export type ProductList = {
    id: number;
    product: Product[];
}
export const getProductList = async (_order_id: number): Promise<ProductList> => {
    return await getForexProductList() as unknown as ProductList;
}
export const cancelForexOrder = async (data: CancelPayload): Promise<any> => {
  return await cancelOnCore({ reason: data.reason, feeMinor: data.feeMinor });
};
